import dayjs from "dayjs";
import { decriptApiKeys } from "../../components/Api/APICall";

const initialState = {
  data: {},
  isLogin: true,
  ActiveRole: [],
};

const UserDataReducer = (state = initialState, { type, payload }) => {
  const locallData = localStorage.getItem("isLogin");
  if (locallData) {
    const decodeData = decriptApiKeys(locallData);
    if (decodeData.status) {
      let decode = JSON.parse(decodeData.data);
      if (dayjs(decode.expiryDate) >= dayjs()) {
        state.data = decode;
        // console.log("locallData",decode);
      } else {
        localStorage.removeItem("isLogin");
      }
    }
  }
  state.isLogin = locallData ? true : false;
  switch (type) {
    case "SET_USERLOGIN_DATA":
      return { ...state, ...payload };
    case "ACTIVE_ROLE_DATA":
      return { ...state, ActiveRole: payload };
    default:
      return state;
  }
};

export default UserDataReducer;
